// Validation for "where to land after signing in".
//
// An invoice message links straight to /invoices/:id; tapping it while signed
// out bounces to login, and the destination has to survive that round trip.
// WHERE it is stored is platform-specific (localStorage vs secure storage), so
// only the validation lives here.

/** Shapes we are willing to send someone to. Anything else is ignored. */
const ALLOWED = [
  /^\/$/,
  /^\/invoices$/,
  /^\/invoices\/[A-Za-z0-9_-]+$/,
  /^\/invoices\/[A-Za-z0-9_-]+\/communications$/,
  /^\/payments$/,
];

/**
 * Validated even though it is only ever used as an in-app route: a
 * protocol-relative or absolute value would turn the login flow into an open
 * redirect.
 */
export function isSafeReturnPath(path: string): boolean {
  if (!path.startsWith('/') || path.startsWith('//')) return false;
  if (path.includes('\\') || path.includes('..')) return false;
  const pathname = path.split(/[?#]/)[0] ?? '';
  return ALLOWED.some(pattern => pattern.test(pathname));
}

/** Whether a path is worth remembering at all — "/" is where we land anyway. */
export function isWorthRemembering(path: string): boolean {
  return isSafeReturnPath(path) && path !== '/';
}
